/* eslint-disable react/prop-types */
import { Grid, darken } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import { API_ROUTES } from "../../../utils/constants";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

function ActionLog() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const axiosPrivateInstance = useAxiosPrivate();
  const [tableData, setTableData] = useState({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [paramsState, setParamsState] = useState({
    ngay: new Date(),
  });

  // Lấy toàn bộ dữ liệu
  const fetchData = async ({ ngay }, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    let body = {
      ngay:
        ngay && dayjs(ngay)?.isValid()
          ? dayjs(ngay).format("YYYY-MM-DD")
          : undefined,
      pageNumber: pageIndex + 1,
      countNumber: pageSize,
    };
    await axiosPrivateInstance
      .get(API_ROUTES.ACTIONLOG, {
        params: body,
      })
      .then((res) => {
        setRowCount(res.data?.totalRecord);
        setTableData(res.data?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
        return;
      })
      .finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };
  useEffect(() => {
    fetchData(paramsState, pagination);
  }, [paramsState, pagination]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "username",
        header: "Người dùng",
        size: 120,
      },
      {
        accessorKey: "titleAction",
        header: "Tiêu đề",
        size: 250,
      },
      {
        accessorKey: "changes",
        header: "Thao tác",
        size: 250,
      },
      {
        accessorKey: "timestamp",
        header: "Ngày giờ truy cập",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY HH:mm")
            : value;
        },
      },
    ],
    []
  );

  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        ngay: value,
      };
    });
  };

  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      ngay: null,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={3} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.ngay ? dayjs(paramsState.ngay) : null}
                onChange={handleChangeDate}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn ngày---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Ngày"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 80,
            },
          }}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ActionLog;
